import computeUserLastCompany from 'utils/computeUserLastCompany';
import resolveSafeReturnTarget from 'utils/safeReturnTarget';
import redirect from 'utils/redirect';

const DEFERRAL_PREFIX = 'passkey-enrollment:deferral:';
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

const deferralKey = userId => `${DEFERRAL_PREFIX}${userId}`;
export const getPasskeyEnrollmentDeferral = (userId, storage = window.localStorage) => {
  if (!userId) {
    return null;
  }
  try {
    const value = storage.getItem(deferralKey(userId));
    const deferredUntil = value && new Date(value);
    return deferredUntil && !Number.isNaN(deferredUntil.getTime()) ? deferredUntil : null;
  } catch {
    return null;
  }
};

export const deferPasskeyEnrollment = (userId, now = new Date(), storage = window.localStorage) => {
  if (!userId) {
    return null;
  }
  const deferredUntil = new Date(new Date(now).getTime() + THIRTY_DAYS_MS);
  try {
    storage.setItem(deferralKey(userId), deferredUntil.toISOString());
  } catch {
    // A blocked local storage must never keep a person in the login flow.
  }
  return deferredUntil;
};

export const shouldShowPasskeyEnrollment = ({
  userId,
  loginMethod,
  supported,
  credentialCount,
  deferredUntil,
  now = new Date(),
}) => {
  const deferralDate = deferredUntil instanceof Date ? deferredUntil : new Date(deferredUntil);
  const hasActiveDeferral = !Number.isNaN(deferralDate.getTime()) && deferralDate > now;
  return Boolean(
    userId && loginMethod === 'sms' && supported && credentialCount === 0 && !hasActiveDeferral,
  );
};

export const continueAfterEnrollment = (returnUrl, user) => {
  const { subDomain } = computeUserLastCompany(user) || {};
  const safe = resolveSafeReturnTarget(returnUrl, user);
  if (safe) {
    const { target } = safe;
    redirect(`${target.pathname}${target.search}${target.hash}`, safe.subDomain || subDomain || '');
    return;
  }
  if (!user?.companies?.length) {
    redirect('/auth/login-no-invitation');
    return;
  }
  redirect('/home/messages', subDomain);
};
